import { render, staticRenderFns } from "./b_data_management.vue?vue&type=template&id=00bdb718&scoped=true&"
import script from "./b_data_management.vue?vue&type=script&lang=js&"
export * from "./b_data_management.vue?vue&type=script&lang=js&"
import style0 from "./b_data_management.vue?vue&type=style&index=0&id=00bdb718&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bdb718",
  null
  
)

export default component.exports